import React, { Component } from 'react'
import { useFela } from 'react-fela'
import View from '../view/view'

const Image = ({
  children,
  className,
  mode,
  src,
  svg,
  svgWidth,
  svgHeight,
  innerRef = null,
  as: As = 'div',
  extend,
  ...props
}) => {

  const { css } = useFela(props)

  const modes = {
    'fill': 'cover',
    'fit': 'contain'
  }
  const size = modes[mode] || 'contain'

  const defaultStyle = {
    backgroundColor: 'none',
    backgroundImage: `url("${src}")`,
    backgroundSize: size,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat'
  }

  if (svg) return (
    <View style={extend}>
      <img width={svgWidth} height={svgHeight} src={svg} />
    </View>
  )

  return (
    <As
      {...props}
      ref={innerRef}
      className={css(defaultStyle, extend) + (className ? ' ' + className : '')}
    >
      {children}
    </As>
  )

  // <div {...props} style={{...defaults, ...style, ...important}} />
}

export default Image